module.exports = __webpack_public_path__ + "media/customizations/amblebrook/back-1fd7010e74a39d2b08b1190c6dca83d9.jpg";